<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";

const props = defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
  isWhite: {
    type: Boolean,
    default: false,
  },
  fullHeight: {
    type: Boolean,
    default: false,
  },
  isHideClose: {
    type: Boolean,
    default: false,
  },
  closeOutSide: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

const handleClose = () => {
  emit("close");
};
</script>

<template>
  <div class="base-modal__wrap" v-if="props.isShow">
    <BaseFigureForIcon
      icon="close"
      color="white"
      --is-button
      class="base-modal__close"
      :class="{
        'base-modal--hide': isHideClose,
        'base-modal--outside': closeOutSide,
      }"
      @click="handleClose"
    />
    <div
      class="base-modal"
      :class="{
        'base-modal--white': isWhite,
        'base-modal--fullheight': fullHeight,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/colors";

.base-modal {
  min-width: 500px;
  max-width: 800px;
  width: 100%;
  border-radius: 24px 24px 0 0;

  @media (max-width: 768px) {
    height: 100%;
    max-width: 768px;
    min-width: 260px;
    bottom: 0;
    position: absolute;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    max-height: 60%;
    padding-bottom: 90px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &--white {
    background-color: var(--color-white);
  }

  &--fullheight {
    @media (max-width: 768px) {
      max-height: 100% !important;
    }
  }

  &--hide {
    @media (max-width: 768px) {
      display: none;
    }
  }

  &--outside {
    display: flex;
    right: -50px !important;
    top: 0 !important;
  }
}

.base-modal__wrap {
  width: 100%;
  height: 100vh;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
}

.base-modal__close {
  position: fixed;
  top: 5%;
  right: 5%;
  cursor: pointer;
}
</style>
